import * as React from 'react';
import {useEffect, useRef, useState} from "react";

import {SpeedDial, SpeedDialAction, SpeedDialIcon} from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import PaidIcon from "@mui/icons-material/Paid";
import WebIcon from "@mui/icons-material/Web";

const actions = [
    { icon: <PublicIcon />, name: 'Social Info', type: 'social' },
    { icon: <PaidIcon />, name: 'Donation info', type: 'donation' },
    { icon: <WebIcon />, name: 'Image upload', type: 'image' },
    // { icon: <WebIcon />, name: 'External widget', type: 'iframe' },
];

export const AddWidgets = ({ onAddWidget = () => {} }) => {
    const [openDial, setOpenDial] = useState(false);

    const handleOpen = () => setOpenDial(true);
    const handleClose = () => setOpenDial(false);
    const addWidget = (type) => {
        onAddWidget(type);
        handleClose();
    }

    return (
        <SpeedDial
            ariaLabel="SpeedDial basic example"
            sx={{ position: 'absolute', bottom: 20, right: 16 }}
            icon={<SpeedDialIcon />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={openDial}
        >
            {actions.map((action) => (
                <SpeedDialAction
                    key={action.name}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    tooltipOpen
                    onClick={() => addWidget(action.type)}
                />
            ))}
        </SpeedDial>
    );
}
